import * as types from "./actionTypes";
import { findIndex } from 'lodash';

let initialState = {
  id: null,
  status: null,
  financialTrustpassDocuments: [],
  data_point_values: [],
};

export default function financialTrustpass(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_FINANCIAL_TRUSTPASS:
      return {
        ...state,
        id: action.payload.id,
        status: action.payload.status,
        financialTrustpassDocuments: action.payload.financial_trustpass_documents,
        data_point_values: action.payload.data_point_values,
      };
    case types.FINANCIAL_TRUSTPASS_HYDRATE:
      return action.payload;
    case types.UPDATE_FINANCIAL_TRUSTPASS_DOCUMENT:
      let updatedDoc = [...state.financialTrustpassDocuments].splice(
        findIndex(state.financialTrustpassDocuments, (doc) => {return doc.id === action.payload.id}), 1,
        action.payload
      );

      return { ...state, financialTrustpassDocuments: updatedDoc };
    case types.RECEIVE_FINANCIAL_TRUSTPASS_DOCUMENT:
      const doc = [...state.financialTrustpassDocuments].concat(
        action.payload
      );

      return { ...state, financialTrustpassDocuments: doc };
    default:
      return state;
  }
}





// WEBPACK FOOTER //
// ./src/features/financial-trustpass/reducers.js